// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { getCookie } from './http/auth.js';

const ProtectedRoute = ({ element: Component }) => {
  //const token = getCookie('token');
  const token = getCookie('username');

  return token ? <Component /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
